module.exports = __webpack_public_path__ + "img/high-converting.ab2d32e5.png";